import React from 'react'
import SbEditable from 'storyblok-react'
import { Dropdown as DropdownUI } from '@/components/ui/dropdown'
export type DropdownBlok = StoryblokComponent & {
  id: string
  name: string
  label: string
  items: string
  marginTop?: number
  marginBottom?: number
}

export interface DropdownProps {
  blok: DropdownBlok
}

export const Dropdown = ({ blok }: DropdownProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''
  const selections = blok.items.split(',').map((item) => item.trim())

  return (
    <div
      className="w-full"
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <DropdownUI label={blok.label} items={selections} className='w-full' id={blok.id} name={blok.name}/>
      </SbEditable>
    </div>
  )
}

Dropdown.displayName = 'Dropdown Block'
